<template>
    <div
      :class="classes({ 'safe-area-inset-bottom': this.safeAreaInsetBottom })"
    >
      <slot></slot>
    </div>
</template>
<script>
import { useBEM } from '../../../common/utils/classnames';
let classnames = useBEM( 'hanzo-goods-action' );
export default {
    name: 'h-goods-action',
    props: {
        safeAreaInsetBottom: Boolean
    },
    methods: {
        classes( arg ) {
            return classnames( arg );
        },
    }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>
